"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDependents = exports.findChildren = exports.findSpouse = exports.findApplicant = void 0;
const index_1 = require("../../index");
/**
 * Get the applicant of a member
 *
 * @public
 * @param {IMember[]} members - The members to search in
 *
 * @returns {IApplicant | undefined} The applicant of the member
 *
 * @example
 * ```ts
 * const applicant = findApplicant(members);
 * ```
 */
function findApplicant(members) {
    const applicant = members.find((member) => member.type === index_1.MemberType.Applicant);
    if (applicant) {
        return applicant;
    }
    return undefined;
}
exports.findApplicant = findApplicant;
/**
 * Get the spouse of a member
 *
 * @public
 * @param {IMember[]} members - The members to search in
 *
 * @returns {ISpouse | undefined} The Spouse of the member
 *
 * @example
 * ```ts
 * const spouse = findSpouse(members);
 * ```
 */
function findSpouse(members) {
    const spouse = members.find((member) => member.type === index_1.MemberType.Spouse);
    if (spouse) {
        return spouse;
    }
    return undefined;
}
exports.findSpouse = findSpouse;
/**
 * Get children of a member
 *
 * @public
 * @param {IMember[]} members - The members to search in
 *
 * @returns {IChild[]} The children of the member
 *
 * @example
 * ```ts
 * const applicant = findChildren(members, memberId);
 * ```
 */
function findChildren(members) {
    return members.filter((member) => member.type === index_1.MemberType.Child);
}
exports.findChildren = findChildren;
/**
 * Get non-applicant members
 *
 * @public
 * @param {IMember[]} members - Members
 * @returns {IDependent[]} - Non-applicant members
 *
 * @example
 * ```ts
 * const result = findDependents(members);
 * ```
 */
function findDependents(members) {
    return members.filter((member) => member.type !== index_1.MemberType.Applicant);
}
exports.findDependents = findDependents;
//# sourceMappingURL=find-member-by-type.js.map